import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

import ItemReview from './ItemReview/ItemReview';


const Reviews = ({ id }) => {
	const content = [
		{
			name: 'Stas1990',
			image: 'assets/images/mainPage/reviews/review_1.png',
			review: 'Спасибо всем ревьюерам за обучение! Было просто супер. Я узнал так много новой информации!! Озднозначно буду рекомендовать эту школ своим друзьям'
		},
		{
			name: 'Аня Носова',
			image: 'assets/images/mainPage/reviews/review_2.png',
			review: 'Школа классная. Мне понравилось, что можно выбрать график самостоятельно. Это большой плюс'
		},
		{
			name: 'Джейсон Стейтем',
			review: 'Было интересно обучаться. Рекомндую всем.'
		},
		{
			name: 'Иван Ручкин',
			image: 'assets/images/mainPage/reviews/review_3.png',
			review: 'Обучился Java разработке за три месяца, хотя в других школах обучение в 2-3 раза дольше идет. Уже нашел первую работу по специальности в крупном банке. Спасибо всем за обучение!'
		},
		{
			name: 'Степан',
			image: 'assets/images/mainPage/reviews/review_4.png',
			review: 'Согласен с Иваном. Обучение и правда идет очень быстро, но все необходимые навыки для трудоустройтсва можно легко получить.'
		}
	]
	const ident = id;

	return (
		<div id={ident} className="main__reviews reviews-main">
			<div className="reviews-main__body">
				<h2 className="reviews-main__title _title">Отзывы</h2>
				<div className="reviews-main__items">
					<Swiper
						spaceBetween={30}
						slidesPerView={'auto'}
					>
						{content.map((item, idx) =>
							<SwiperSlide key={item.name + idx}>
								<ItemReview content={item} />
							</SwiperSlide>
						)}
					</Swiper>
				</div>
			</div>
		</div>
	)
}


export default Reviews;